import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Contexts/AppContext";

const FilterProject = ({
  setActiveCategory,
  activeCategory,
  setFiltered,
  tutorials,
}) => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["business"].bg
        : context.currentTheme["business"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["business"].text
        : context.currentTheme["business"].dark_text
    );
  }, [context]);

  useEffect(() => {
    if (activeCategory === "All") {
      setFiltered(tutorials);
    } else {
      const filtered = tutorials.filter(
        (tutorial) => tutorial.category.catName === activeCategory
      );
      setFiltered(filtered);
    }
  }, [activeCategory, setFiltered, tutorials]);

  return (
    <div className="filter-container mb-2 mt-2 px-4 md:mb-4 md:mt-4 md:px-10 xl:px-20">
      <button
        className="primary-font mx-1 my-2 mt-0 cursor-pointer rounded-md border-2 py-1 px-4 text-sm outline-none transition-all ss:py-2 lg:m-2 lg:text-base"
        style={{
          backgroundColor: activeCategory === "All" ? currentText : currentBG,
          color: activeCategory === "All" ? currentBG : currentText,
          borderColor: activeCategory === "All" ? currentBG : currentText,
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = currentBG;
          e.target.style.backgroundColor = currentText;
          e.target.style.color = currentBG;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor =
            activeCategory === "All" ? currentText : currentBG;
          e.target.style.color =
            activeCategory === "All" ? currentBG : currentText;
          e.target.style.borderColor =
            activeCategory === "All" ? currentBG : currentText;
        }}
        onClick={() => setActiveCategory("All")}
      >
        All
      </button>
      <button
        className="primary-font mx-1 my-2 mt-0 cursor-pointer rounded-md border-2 py-1 px-4 text-sm outline-none transition-all ss:py-2 lg:m-2 lg:text-base"
        style={{
          backgroundColor:
            activeCategory === "flowers" ? currentText : currentBG,
          color: activeCategory === "flowers" ? currentBG : currentText,
          borderColor: activeCategory === "flowers" ? currentBG : currentText,
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = currentBG;
          e.target.style.backgroundColor = currentText;
          e.target.style.color = currentBG;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor =
            activeCategory === "flowers" ? currentText : currentBG;
          e.target.style.color =
            activeCategory === "flowers" ? currentBG : currentText;
          e.target.style.borderColor =
            activeCategory === "flowers" ? currentBG : currentText;
        }}
        onClick={() => setActiveCategory("flowers")}
      >
        Flowers
      </button>
      <button
        className="primary-font mx-1 my-2 mt-0 cursor-pointer rounded-md border-2 py-1 px-4 text-sm outline-none transition-all ss:py-2 lg:m-2 lg:text-base"
        style={{
          backgroundColor: activeCategory === "tops" ? currentText : currentBG,
          color: activeCategory === "tops" ? currentBG : currentText,
          borderColor: activeCategory === "tops" ? currentBG : currentText,
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = currentBG;
          e.target.style.backgroundColor = currentText;
          e.target.style.color = currentBG;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor =
            activeCategory === "tops" ? currentText : currentBG;
          e.target.style.color =
            activeCategory === "tops" ? currentBG : currentText;
          e.target.style.borderColor =
            activeCategory === "tops" ? currentBG : currentText;
        }}
        onClick={() => setActiveCategory("tops")}
      >
        Tops
      </button>
      <button
        className="primary-font mx-1 my-2 mt-0 cursor-pointer rounded-md border-2 py-1 px-4 text-sm outline-none transition-all ss:py-2 lg:m-2 lg:text-base"
        style={{
          backgroundColor:
            activeCategory === "animals" ? currentText : currentBG,
          color: activeCategory === "animals" ? currentBG : currentText,
          borderColor: activeCategory === "animals" ? currentBG : currentText,
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = currentBG;
          e.target.style.backgroundColor = currentText;
          e.target.style.color = currentBG;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor =
            activeCategory === "animals" ? currentText : currentBG;
          e.target.style.color =
            activeCategory === "animals" ? currentBG : currentText;
          e.target.style.borderColor =
            activeCategory === "animals" ? currentBG : currentText;
        }}
        onClick={() => setActiveCategory("animals")}
      >
        Animals
      </button>
      <button
        className="primary-font mx-1 my-2 mt-0 cursor-pointer rounded-md border-2 py-1 px-4 text-sm outline-none transition-all ss:py-2 lg:m-2 lg:text-base"
        style={{
          backgroundColor:
            activeCategory === "blankets" ? currentText : currentBG,
          color: activeCategory === "blankets" ? currentBG : currentText,
          borderColor: activeCategory === "blankets" ? currentBG : currentText,
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = currentBG;
          e.target.style.backgroundColor = currentText;
          e.target.style.color = currentBG;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor =
            activeCategory === "blankets" ? currentText : currentBG;
          e.target.style.color =
            activeCategory === "blankets" ? currentBG : currentText;
          e.target.style.borderColor =
            activeCategory === "blankets" ? currentBG : currentText;
        }}
        onClick={() => setActiveCategory("blankets")}
      >
        Blankets
      </button>
      <button
        className="primary-font mx-1 my-2 mt-0 cursor-pointer rounded-md border-2 py-1 px-4 text-sm outline-none transition-all ss:py-2 lg:m-2 lg:text-base"
        style={{
          backgroundColor: activeCategory === "bags" ? currentText : currentBG,
          color: activeCategory === "bags" ? currentBG : currentText,
          borderColor: activeCategory === "bags" ? currentBG : currentText,
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = currentBG;
          e.target.style.backgroundColor = currentText;
          e.target.style.color = currentBG;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor =
            activeCategory === "bags" ? currentText : currentBG;
          e.target.style.color =
            activeCategory === "bags" ? currentBG : currentText;
          e.target.style.borderColor =
            activeCategory === "bags" ? currentBG : currentText;
        }}
        onClick={() => setActiveCategory("bags")}
      >
        Bags
      </button>
    </div>
  );
};

export default FilterProject;
